import {
    type Element,
    type SlateEditor,
} from '@udecode/plate';

import { BaseFigureCaptionPlugin } from '../FigureCaptionBasePlugin';
import type { FigureKind, TFigureCaptionElement } from '../types';

export const changeFigureKind = (
    editor: SlateEditor,
    at: Element,
    figureKind: FigureKind
) => {
    const currentElement = editor.api.block({
        at,
        match: { type: editor.getType(BaseFigureCaptionPlugin) },
    });

    if (!currentElement) {
        return;
    }

    editor.tf.withoutNormalizing(() => {
        editor.tf.setNodes<TFigureCaptionElement>(
            {
                ...currentElement[0],
                figureKind
            },
            {
                at: at,
            }
        );
    });
};
